import React from 'react';
import { motion } from 'framer-motion';
import { revenueScenarios, revenueStreams } from '../../data/invest';
import { fadeUp } from '../../utils/motion';
export function InvestRevenue() {
  return <>
      {/* Revenue streams */}
      <section className="bg-surface-bg py-20 lg:py-28" data-id="element-1345" data-mp="3ufmntc5z3jfl">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1346" data-mp="39bgiyaddmft">
          <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 mb-12" data-id="element-1347" data-mp="3amlv2jgr291">
            <h2 className="lg:col-span-5 font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight" data-id="element-1348" data-mp="31ss6go4gd06c">
              Multiple routes to revenue
            </h2>
            <p className="lg:col-span-7 text-xl text-ink-dark leading-relaxed" data-id="element-1349" data-mp="3bqptx9ehmsxw">
              SyNeural’s proposed business model combines initial project revenue
              with ongoing customer relationships.
            </p>
          </motion.div>

          <motion.div {...fadeUp} className="bg-white border border-line rounded-lg overflow-x-auto" data-id="element-1350" data-mp="uz7tvlootydr">
            <table className="w-full min-w-[36rem] text-left" data-id="element-1351" data-mp="33pcgwliulc8">
              <thead data-id="element-1352" data-mp="3ub1t9aihswrm">
                <tr className="border-b border-line bg-surface-muted" data-id="element-1353" data-mp="3uas41p59utmz">
                  <th scope="col" className="w-1/3 px-6 py-4 text-sm font-semibold text-ink-dark" data-id="element-1354" data-mp="3pbyntoylooj4">
                    Revenue stream
                  </th>
                  <th scope="col" className="px-6 py-4 text-sm font-semibold text-ink-dark" data-id="element-1355" data-mp="3l9ty31b9wc1r">
                    What customers would purchase
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-1356" data-mp="3bj92lmqwbnn2">
                {revenueStreams.map(row => <tr key={row.stream} className="border-b border-line last:border-b-0 align-top" data-id="element-1357" data-mp="36mimizf3cs1n">
                    <th scope="row" className="px-6 py-5 font-heading font-bold text-ink-dark" data-id="element-1358" data-mp="31nfgbbndkfs3">
                      {row.stream}
                    </th>
                    <td className="px-6 py-5 text-ink-muted leading-relaxed" data-id="element-1359" data-mp="2slpq2958bmvw">{row.purchase}</td>
                  </tr>)}
              </tbody>
            </table>
          </motion.div>

          <motion.p {...fadeUp} className="mt-8 max-w-3xl text-lg text-ink-muted leading-relaxed" data-id="element-1360" data-mp="2mzp7b9rr9o63">
            Commercial packages would define what is included so customers
            receive a clear offer. Pricing could vary by deployment scope, users,
            modules, service levels, and infrastructure requirements.
          </motion.p>
        </div>
      </section>

      {/* Revenue scenarios */}
      <section className="bg-white py-20 lg:py-28" data-id="element-1361" data-mp="36nesuz93ms6v">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-1362" data-mp="36n5239g8ch04">
          <motion.div {...fadeUp} className="lg:col-span-5" data-id="element-1363" data-mp="2rwo1fsbf5v4a">
            <h2 className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight mb-6" data-id="element-1364" data-mp="2wwtlonfd0fcc">
              Revenue scenarios
            </h2>
            <p className="text-lg text-ink-muted leading-relaxed" data-id="element-1365" data-mp="3pdw8c24x7raa">
              At an illustrative $100,000 in annual recurring revenue per
              institutional customer:
            </p>
          </motion.div>

          <div className="lg:col-span-7" data-id="element-1366" data-mp="190vrgf6wll6g">
            <motion.figure {...fadeUp} data-id="element-1367" data-mp="18zu7tmbtnqd4">
              <table className="w-full border border-line rounded-lg overflow-hidden" data-id="element-1368" data-mp="1ms0kuzjohh8c">
                <thead data-id="element-1369" data-mp="1iq5li0lb5dx7">
                  <tr className="border-b border-line bg-surface-muted" data-id="element-1370" data-mp="1ipnh2gohrte7">
                    <th scope="col" className="text-left px-6 py-4 text-sm font-semibold text-ink-dark" data-id="element-1371" data-mp="v01invfy1i79">
                      Institutional customers
                    </th>
                    <th scope="col" className="text-right px-6 py-4 text-sm font-semibold text-ink-dark" data-id="element-1372" data-mp="q3b091go2aio">
                      Annual recurring revenue
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-1373" data-mp="2ffwefvdyat0w">
                  {revenueScenarios.map(row => <tr key={row.customers} className="border-b border-line last:border-b-0" data-id="element-1374" data-mp="2fhzfrbkk08kx">
                      <th scope="row" className="text-left font-heading font-bold text-xl text-ink-dark px-6 py-5" data-id="element-1375" data-mp="2aj5zxchso5hl">
                        {row.customers}
                      </th>
                      <td className="text-right font-heading font-extrabold text-3xl text-navy px-6 py-5 whitespace-nowrap" data-id="element-1376" data-mp="3aql5nxnfkxsn">
                        {row.revenue}
                      </td>
                    </tr>)}
                </tbody>
              </table>
              <figcaption className="mt-4 text-sm text-ink-dark leading-relaxed bg-surface-bg border-l-2 border-teal px-5 py-4 rounded-r-md" data-id="element-1377" data-mp="3opcg9a3341c1">
                These are illustrative scenarios, not current revenue, signed
                contracts, or forecasts. Revenue is not profit: engineering,
                infrastructure, third-party technology, implementation, sales, and
                support all carry costs.
              </figcaption>
            </motion.figure>

            <motion.div {...fadeUp} className="mt-10 space-y-5" data-id="element-1378" data-mp="g9sran9g552s">
              <p className="text-lg text-ink-muted leading-relaxed" data-id="element-1379" data-mp="g7y2uyyyuuty">
                Implementation fees and separately contracted projects could
                generate additional revenue. Larger deployments spanning
                departments or agencies could support higher annual contract
                values.
              </p>
              <p className="text-lg text-ink-muted leading-relaxed" data-id="element-1380" data-mp="1mtdcky0asrf2">
                Noetivra also creates a potential route to smaller organizations
                and teams through standardized subscriptions. That opportunity
                would depend on proving that onboarding, support, and delivery can
                be made economical at a smaller contract size.
              </p>
            </motion.div>
          </div>
        </div>
      </section>
    </>;
}